import React, { useState } from 'react';
import AdaptiveHeader from '../AdaptiveHeader';
import AdaptiveProductGrid from '../AdaptiveProductGrid';
import SmartClientLogin from '../client/SmartClientLogin';

const ProductCatalog = () => {
    const [showClientLogin, setShowClientLogin] = useState(false);

    const handleShowClientLogin = () => {
        setShowClientLogin(true);
    };

    const handleCloseClientLogin = () => {
        setShowClientLogin(false);
    };

    return (

            <div className="container">
                {/* Header adaptatif selon l'état de connexion */}
                <AdaptiveHeader 
                    onShowClientLogin={handleShowClientLogin}
                />
                {/* Grille des produits adaptative */}
                <AdaptiveProductGrid />
                {/* Modal de connexion client */}
                {showClientLogin && (
                    <SmartClientLogin onClose={handleCloseClientLogin} />
                )}
            </div>
    );
};

export default ProductCatalog;
